import { FC, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  getCarBrandById,
  putCarBrand,
} from "../../app/services/carBrandService";
import { useAppDispatch } from "../../app/hooks";
import { useAccount, useMsal } from "@azure/msal-react";

import Form from "react-bootstrap/Form";
import { Alert, Breadcrumb, Button, Col, Row } from "react-bootstrap";
import { CarBrand, defaultCarBrand } from "../../models/responses/carBrand";
import { useSelector } from "react-redux";
import { RootState } from "../../app/store";

interface Props {}

const CarBrandEdit: FC<Props> = () => {
  const { carBrandId } = useParams<{ carBrandId: string }>();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { instance, accounts } = useMsal();
  const account = useAccount(accounts[0] || {});
  const [displayError, setDisplayError] = useState(false);
  const isWaitingCustomerPutResponse = useSelector(
    (state: RootState) => state.customer.isWaitingCustomerPutResponse
  );
  const carBrand = useSelector((state: RootState) => state.carBrand.carBrand);
  const [carBrandData, setCarBrandData] = useState<CarBrand>(defaultCarBrand);

  useEffect(() => {
    dispatch(getCarBrandById(instance, account, carBrandId));
  }, [account, accounts, dispatch, instance, carBrandId]);
  useEffect(() => {
    if (carBrand) {
      setCarBrandData({
        id: carBrand.id,
        name: carBrand.name,
        createdAt: carBrand.createdAt,
        deletedAt: carBrand.deletedAt,
        updatedAt: carBrand.updatedAt,
      });
    }
  }, [carBrand]);

  const nameInputHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    setCarBrandData({ ...carBrandData, name: e.target.value });
  };

  const handleUpdateCarBrand = () => {
    setDisplayError(false);
    dispatch(putCarBrand(instance, account, carBrandData, onSuccess));
  };

  const onSuccess = (carBrandId: string | null) => {
    if (carBrandId === null) {
      setDisplayError(true);
      return;
    }

    setTimeout(() => {
      navigate(`../../${carBrandId}`, { relative: "path" });
    }, 500);
  };

  return (
    <div>
      <Breadcrumb>
        <Breadcrumb.Item href="/car-brands">Bilmärken</Breadcrumb.Item>
        <Breadcrumb.Item active>Uppdatera bilmärke</Breadcrumb.Item>
      </Breadcrumb>
      <hr />
      <Form className="w-3">
        <Row>
          <Col xs={12} md={6}>
            <Form.Group className="mb-3">
              <Form.Label>Bilmärke *</Form.Label>
              <Form.Control
                type="text"
                value={carBrandData.name}
                onInput={nameInputHandler}
              />
            </Form.Group>
          </Col>
        </Row>
        <div className="text-end">
          <Button
            variant="primary"
            className="mb-3"
            onClick={handleUpdateCarBrand}
            disabled={
              !(
                carBrandData.name !== undefined &&
                carBrandData.name.length > 0 &&
                !isWaitingCustomerPutResponse
              )
            }
          >
            Uppdatera bilmärke
          </Button>
        </div>

        <Alert key="alert" variant="danger" show={displayError}>
          <p>Något gick fel, kontrollera uppgifterna och försök igen.</p>
        </Alert>
      </Form>
    </div>
  );
};

export default CarBrandEdit;
